import { Article } from '../types.ts';

/**
 * Servizio Gemini per CalCost.
 * Chiama il proxy Express /api/calcost/insights (API key server-side).
 * Riceve SSE streaming.
 */
const geminiService = {
  getCollectionInsights: async function* (articles: Article[]) {
    try {
      const response = await fetch('/api/calcost/insights', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ articles }),
      });

      if (!response.ok) {
        const err = await response.json().catch(() => ({ error: 'Errore sconosciuto' }));
        yield `
          <div class="text-center p-4 bg-red-100 text-red-800 rounded-lg">
            <h4 class="font-bold">Errore</h4>
            <p>${err.error || 'Errore durante la richiesta al server.'}</p>
          </div>
        `;
        return;
      }

      const reader = response.body?.getReader();
      if (!reader) {
        yield 'Errore: streaming non supportato dal browser.';
        return;
      }

      const decoder = new TextDecoder();
      let buffer = '';

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });

        // Processa le righe SSE
        const lines = buffer.split('\n');
        buffer = lines.pop() || ''; // L'ultima riga potrebbe essere incompleta

        for (const line of lines) {
          if (line.startsWith('data: ')) {
            const data = line.slice(6);
            if (data === '[DONE]') return;

            try {
              const parsed = JSON.parse(data);
              if (parsed.error) {
                yield parsed.error;
                return;
              }
              if (parsed.text) {
                yield parsed.text;
              }
            } catch {
              // Ignora righe JSON malformate
            }
          }
        }
      }
    } catch (error) {
      console.error('Error calling CalCost insights API:', error);
      yield 'Si è verificato un errore durante la generazione dei suggerimenti. Controlla la console per i dettagli.';
    }
  }
};

export default geminiService;
